import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {from, Observable} from 'rxjs';

const ICONSMAP = [
  'apartment',
  'briefcase',
  'universal-access',
];

const ENVIRONMENT = {
  DEV: 'https://cdn.dev.apps.calibrantenergy.net',
  SOAK: 'https://cdn.dev.apps.calibrantenergy.net',
  PRD: 'https://cdn.apps.calibrantenergy.com',
};

function getEnvironmentUrl() {
  let cdnURL = ENVIRONMENT.DEV;
  if (window.location.href.search('.soak.apps.calibrantenergy.net') !== -1) {
    cdnURL = ENVIRONMENT.SOAK;
  } else if (window.location.href.search('.apps.calibrantenergy.com') !== -1) {
    cdnURL = ENVIRONMENT.PRD;
  }
  return cdnURL;
}


@Injectable({ providedIn: 'root' })
export class IconsService {
  cdnUrl = getEnvironmentUrl();
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  load(): Observable<unknown> {
    return from(new Promise<void>(resolve => {
      ICONSMAP.forEach(ico => {
        this.iconRegistry.addSvgIcon(
          ico,
          this.sanitizer.bypassSecurityTrustResourceUrl(
            `${this.cdnUrl}/img/icons/${ico}.svg`,
          ),
        );
      });
      resolve();
    }));
  }
}
